import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideRebuild = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRidesRebuildProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideRebuild,
    entity,
  );

  const bulkRidesRebuildProcess = useRecoilValue(
    activeProcessSF(bulkRidesRebuildProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideRebuild,
      toastSummaryOnComplete: true,
      process: bulkRidesRebuildProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkRidesRebuildProcess, entity, onComplete, stopProcessPolling, t]);
};
